<template>
  <div
    v-if="newsletter"
    class="newsletter-card"
  >

    <div class="newsletter-card__aside">
      <img
        loading="lazy"
        v-if="newsletter.imgSrc && !imageError"
        class="object-cover h-full w-full"
        :src="newsletter.imgSrc"
        :alt="newsletter.title || ''"
        width="320"
        height="213"
        @error="replaceByDefault"
      >
      <!--no profile-pic -->
      <DefaultIconsAccount v-if="!newsletter.imgSrc || imageError" />
      <!--no profile-pic -->
    </div>

    <div class="newsletter-card__body">
      <div class="flex flex-col-reverse lg:flex-row gap-2 lg:gap-4 items-start lg:items-center">
        <h2>
          {{ newsletter.title }}
        </h2>
        <div class="newsletter-card__interval">
          {{ newsletter.intervalText }}
        </div>
      </div>
      <div class="newsletter-card__text">
        {{ newsletter.text }}
      </div>
      <div class="newsletter-card__action">
        <button
          class="btn btn--lg"
          @click="onSubscribeClick"
        >
          {{ $t('newsletter.subscribe') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue"
import type NewsletterLocal from "~/libs/interfaces/NewsletterLocal"

const props = defineProps({
  newsletter: {type: Object as PropType<NewsletterLocal>, required: true},
})

const emits = defineEmits(['subscribe'])

const onSubscribeClick = () => {
  emits('subscribe', {id: props.newsletter?.contactListId})
}

const imageError = ref(false)

const replaceByDefault = () => {
  imageError.value = true
}

</script>

<style lang="scss" scoped>

</style>
